import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Accordion } from '../../common/commonComponents/Accordion/accordion';
import Loader from 'react-loader-spinner';
import {
	masterServiceBaseUrl,
	deleteAPI,
	getAPI,
} from 'services/http';
import { Container, Card, CardBody, CardHeader, Button, Row } from 'reactstrap';
import { PermissionContext, RolePermissions } from "appContext";
import { endpoint, pages } from "../../common/constant";
import BusinessUnitNewUI from '../component/FirstForm/businessUnitNewUI';
import AddAddress from '../component/LocationAddress';
import ContactHistory from '../component/thirdForm';
import TaxDetails from '../component/taxDetails';
import Franchisee from '../component/Franchisee';
import CashierOffice from '../component/cashierOffice';
import BranchAccount from '../component/branchAccount';
import ApprovalMatric from '../component/approvalMatrix/approvalMatric';
import SAPDetails from '../component/SAP_BusinessArea&Plan';
import PineLabsSetup from '../component/pineLabsSetup';
import LastNumberGenerated from '../component/LastNumberGenerated';
import { useHistory, useParams } from 'react-router-dom';
import { fetchAllPostPromisedData, fetchAllPromisedData, getValueBySearch } from '../../common/utils/methods/commonMethods/utilityMethod';
import './editview.scss';
import IsCoreMaster from '../../common/commonComponents/coreMaster';
import { failureToast, successToast } from '../../common/utils/methods/toasterFunctions/function';
import SapPlantMapping from '../component/FirstForm/sapPlantMapping';
import BusinessUnitFormTabs from '../component/FirstForm';
import { RenderHeaderChip } from '../../unAssigned/collectPayment/header';
import { ReactComponent as InfoIcon } from "../../../../../assets/img/svg/infoIcon.svg"
import { BUPopover } from '../../unAssigned/studentFinanceApproval/epmrCancellation/constant';
import { MasterDataForSelect } from '../../common/utils/methods/commonMethods/masterDataForSelect';
import { getStatus, getStatusCount } from './constant';
import StatusSyncingDropdown from '../component/FirstForm/StatusSyncingDropdown';
// import { BUPopover } from '../../masters/studentFinancials/paymentCollection/manage-receipts/ColumnPopovers';
// import { BUPopover } from '../../masters/studentFinancials/paymentCollection/EPMR/ColumnPopovers';


function BusinessUnitEditViewForm(props) {
	let history = useHistory();

	const permissions = useContext(PermissionContext);
	const userPermissions = RolePermissions(permissions, pages["businessAreaSearch"]['id']);

	const { id, action } = useParams();
	const [isNew, setIsNew] = useState(true);
	const [apiLoader, setApiLoader] = useState(false);
	const [businessAreaDetails, setBusinessAreaDetails] = useState();

	const [groupCodeId, setGroupCodeId] = useState();
	const [groupCodeList, setGroupCodeList] = useState();
	const [groupCodeValue, setGroupCodeValue] = useState();
	const [companyCodeId, setCompanyCodeId] = useState();
	const [companyCodeList, setCompanyCodeList] = useState();
	const [companyCodeValue, setCompanyCodeValue] = useState();
	const [businessTypeId, setBusinessTypeId] = useState();
	const [businessTypeList, setBusinessTypeList] = useState();
	const [businessAreaName, setBusinessAreaName] = useState('');
	const [businessAreaType, setBusinessAreaType] = useState([]);
	const [businessAreaList, setBusinessAreaList] = useState([]);
	const [buDescriptionMap, setBuDescriptionMap] = useState({})
	const [buStatus, setStatus] = useState({})

	const [locationAndContactDetailsData, setLocationAndContactDetailsData] = useState({ fetching: false, data: [] });
	const [anchorEl, setAnchorEl] = useState(null);
	useEffect(() => {
		fetchData(
			masterServiceBaseUrl + `/groupCode/getAllGroupCode`,
			'GroupCode',
			setGroupCodeList
		);
		fetchData(
			masterServiceBaseUrl + `/companyCode/getAllCompanyCode`,
			'CompanyCode',
			setCompanyCodeList
		);
		fetchData(
			masterServiceBaseUrl + `/businessUnitType/getAllBusinessUnitType`,
			'businessType',
			setBusinessTypeList
		);
		MasterDataForSelect(
			// `${masterServiceBaseUrl}/businessArea/getAllBusinessArea`,
			endpoint.businessArea.getAll, //changed to buV2 endpoint
			'businessArea',
			setBusinessAreaList
		);

		// fetchLocationAndContactDetails();
	}, []);

	const fetchBusinessAreaDetails = () => {
		fetchData(
			// masterServiceBaseUrl + `/businessArea/getBusinessAreaDetails/${id}`,
			`${endpoint.businessArea.getBUDetails}/${id}`, //changed to buV2 endpoint
			'userData',
			setBusinessAreaDetails
		);
	}

	const fetchLocationAndContactDetails = async () => {
		try {
			setLocationAndContactDetailsData({ fetching: true, data: [] })

			const resp = await fetchAllPromisedData(`${endpoint.businessArea.getBusinessAreaContactDetailsLocation}/${id}`, true);
			if (resp?.code === 200) {
				const data = [resp?.data?.locationDetailsDto, resp?.data?.contactDetailsMasterDTO];
				setLocationAndContactDetailsData({ fetching: false, data: data })
			} else {
				setLocationAndContactDetailsData({ fetching: false, data: [] })
			}
		} catch (err) {
			console.log(err);
		}
	}

	const fetchData = (url, type, setState) => {
		try {
			setApiLoader(true);
			getAPI(
				url,
				async (data) => {
					if (type === 'userData') {
						setState(data['data']);
						setBusinessAreaName(
							data['data']['businessAreaMasterDTO']['businessAreaDispValue']
						);
						setCompanyCodeId(
							data['data']['businessAreaMasterDTO']['companyCodeId']
						);
						setGroupCodeId(
							data['data']['businessAreaMasterDTO']['groupCodeId']
						);
						setBusinessTypeId(
							data['data']['businessAreaMasterDTO']['businessUnitTypeId']
						);
						setApiLoader(false);
					}
					else {
						setState(data['data']);
					}
				},
				(data) => {
					setApiLoader(false);
					failureToast(data['message']);
				}
			);
		} catch (e) {
			console.log('Error', e);
		}
	};

	const getDisplayCompanyGroupCode = (groupCodeId, companyCodeId) => {
		const groupCodeValue =
			groupCodeId &&
			groupCodeList &&
			getValueBySearch(groupCodeId, groupCodeList, 'groupCodeDispValue');

		const companyCodeValue =
			companyCodeId &&
			companyCodeList &&
			getValueBySearch(companyCodeId, companyCodeList, 'companyCodeDispValue');

		let temp = [];
		const businessUnitValue =
			businessTypeId &&
			businessTypeList &&
			businessTypeId.map((id) => {
				const businessType = getValueBySearch(
					id,
					businessTypeList,
					'businessUnitTypeDispValue'
				);
				businessType && temp.push(' ' + businessType);
			});

		setBusinessAreaType(temp);

		groupCodeValue && setGroupCodeValue(groupCodeValue);
		companyCodeValue && setCompanyCodeValue(companyCodeValue);
	};

	useMemo(() => {
		getDisplayCompanyGroupCode(groupCodeId, companyCodeId);
	}, [
		groupCodeList,
		companyCodeList,
		groupCodeId,
		companyCodeId,
		businessTypeId,
		businessTypeList,
	]);

	
 const statusStyle = {
    INACTIVE	: {
      backgroundColor: "#FFEDC8",
      color: "#705010",
      padding: "4px 11px",
      fontSize: "14px",
      borderRadius: "8px",
    },
    ACTIVE: {
      backgroundColor: "#BBE2CE",
      color: "#0B442D",
      padding: "4px 11px",
      fontSize: "14px",
      borderRadius: "8px",
    },
  };
   const statusMapping = {
    ACTIVE: "Active",
    INACTIVE: 'Inactive',
  };
 
  const status={
	...buStatus
  }
	return (
		<>
			{/* {
			apiLoader ? (
				<div
					className="mx-auto text-center py-5 my-5"
					style={{ height: '100vh' }}
				>
					<Loader type="Rings" color="#00BFFF" height={100} width={100} />{' '}
				</div>
			) : ( */}
			<Card style={{ marginTop: '-16px' }} className='mb-3'>
				<CardHeader className="fixedHeader">
					<h2>Business Area</h2>
					{/* <div className="floatRight mr-auto">
						<IsCoreMaster
							master={'businessArea'}
							masterDisplayValue={'Business Area'}
						/>
					</div> */}
					<div className="right_heading d-flex align-items-center justify-content-center" style={{ gap: '10px' }}>
						<div onClick={(e)=>{setAnchorEl(e.currentTarget)}} className={`ellipsis-text-container cursor`}style={statusStyle?.[getStatus(getStatusCount(status))]} >{getStatusCount(status)}</div>
						<RenderHeaderChip label={"BU"} value={businessAreaName}>
							<BUPopover
								businessArea={businessAreaName}
								businessAreaOptions={businessAreaList}
								buDescriptionMap={buDescriptionMap}
								setBuDescriptionMap={setBuDescriptionMap}
								icon={<InfoIcon />}
								isForceApiCall= {true}
							>
								{businessAreaName}
								</BUPopover>

						</RenderHeaderChip>
						{/* <h4>BU : </h4> <span>{businessAreaName}</span> */}
						<RenderHeaderChip label={"Type"} value={businessAreaType} />
						<RenderHeaderChip label={"SAP Plant ID"} value={businessAreaDetails?.businessAreaMasterDTO?.sapPlantId} />
						{/* <h4>Business Area Type :</h4> <span>{businessAreaType}</span> */}
					</div>
				</CardHeader>
			</Card>
			{/* <CardBody className="customCardBody"> */}
			<div>
				{/* {businessAreaDetails &&
								businessAreaDetails['businessAreaMasterDTO'] ? ( */}
				<>
					{/* <Accordion
										title={`Basic Information`}
										key={'basic_information'}
										isFormOpen={false}
										removePadding={true}
									>
										<BusinessUnitNewUI
											isNew={isNew}
											isPrevious={true}
											action={action}
											formId={id}
											data={businessAreaDetails['businessAreaMasterDTO']}
											userPermissions={userPermissions}
										/>

									</Accordion> */}

					<BusinessUnitFormTabs
						isNew={isNew}
						isPrevious={true}
						action={action}
						formId={id}
						data={businessAreaDetails?.businessAreaMasterDTO}
						userPermissions={userPermissions}
						locationAndContactDetailsData={locationAndContactDetailsData}
						fetchLocationAndContactDetails={fetchLocationAndContactDetails}
						fetchBusinessAreaDetails={fetchBusinessAreaDetails}
						setStatus={setStatus}
					/>

				</>

				{/* 
							<Button
								color="danger"
								size="md"
								type="button"
								className={'floatRight ml-auto'}
								onClick={() => window.close()}
							>
								Close
							</Button> */}
				{/* </CardBody> */}
			</div>

			{/* )} */}
			<StatusSyncingDropdown
				anchorEl={anchorEl}
				setAnchorEl={setAnchorEl}
				view={true}
				statusValue={status}
			/>
		</>
	);
}

export default BusinessUnitEditViewForm;
